<template>
    <section class="pt-20">
        <header id="home" class="h-screen md:h-screen-75 bg-gray-50 flex flex-col-reverse md:grid md:gap-4 md:grid-cols-2">
            <div class="h-full relative bottom-14 xs:bottom-8 md:top-1 md:bottom-0 xl:px-48 3xl:pl-96">
                <div class="flex pl-4 xl:pl-0 h-full lg:w-screen/3 3xl:w-full">
                    <div class="my-auto mx-auto xl:mx-0">
                        <div class="mb-6 md:mb-10 px-4 xl:px-0">
                            <!-- <h1 class="text-4xl md:text-6xl xl:text-8xl font-semibold">Growth <br class="hidden md:block">& Relief</h1>
                            <p class="pt-2 text-gray-800 text-center md:text-left text-base md:text-lg xl:text-xl">
                                There is no health without mental health.
                            </p> -->
                            
                            <p class="font-semibold text-gray-600 text-xl">There is no 
                                <span class="text-2xl" style="color: #5ECE4A">Health</span> 
                                without
                            </p>
                            <h1 class="text-4xl md:text-6xl xl:text-8xl font-bold">Mental Health</h1>
                        </div>
                        <div class="flex">
                            <div class="my-auto mx-auto md:mx-0 px-4 xl:px-0">
                                <router-link to="/donate" class="rounded-full shadow-md px-6 space-x-4 py-3 lg:text-2xl flex border-2 border-dark-green bg-dark-green main-cta text-white hover:bg-white hover:border-2 hover:border-green-500 hover:text-green-500 transition ease-in-out duration-500">
                                     <span class="my-auto">
                                        <svg 
                                            xmlns="http://www.w3.org/2000/svg" 
                                            class="h-7 w-7" 
                                            fill="none" 
                                            viewBox="0 0 24 24" 
                                            stroke="currentColor" 
                                            stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </span>
                                    <span class="font-semibold my-auto">
                                        Donate Therapy
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="h-full w-full  my-auto flex px-4 left-header-side">
                <img src="@/assets/images/mental-health-animate.svg" class="relative xl:-top-6 w-full xl:w-screen-40 my-auto mx-auto 3xl:hidden" alt="">
            </div>
        </header>
         <!-- Why Donate -->
        <section class="h-screen-50 bg-white px-6 py-10 xl:py-24 xl:px-48 3xl:px-96 3xl:py-32" id="why-donate">
            <div class="md:grid md:grid-cols-2 md:gap-10">
                <div class="hidden md:flex">
                    <img 
                        class="md:my-auto"
                        src="@/assets/images/depression-animate.svg" 
                        alt="Depressed Woman">
                </div>
               
                <div class="pl-6">
                    <h5 class="font-semibold text-gray-600">Why Donate?</h5>
                    <h2 class="text-black font-bold text-3xl xl:text-5xl">Why You Should Donate</h2>
                    <div class="py-10">
                        <p class="text-base xl:text-lg pb-2">
                            According to 2022 data, 19.86% of adults in America are experiencing a mental illness. This is equivalent to nearly 50 million Americans.
                        </p>
                        <p class="text-base xl:text-lg py-2">
                           4.91% are experiencing a severe mental illness which can impact their ability to fully function, hold jobs, etc. (source: Mental Health America) 
                        </p>
                        <p class="text-base xl:text-lg py-2">
                            People seeking mental health services may face additional challenges in accessing care due to lack of health insurance coverage and rising health care costs. The Growth & Relief Program helps fill in the gap by offering discounted and free therapy sessions to clients who qualify. 
                        </p>
                        <p class="text-base xl:text-lg py-2">
                            Your donation will help provide therapy to someone who may not otherwise be able to afford it.
                        </p>
                    </div>
                    <div class="md:hidden">
                        <img 
                            class=""
                            src="@/assets/images/depression-animate.svg" 
                            alt="Woman">
                    </div>
                    <div>
                        <router-link to="/donate" class="rounded-full justify-center w-auto lg:w-80 shadow-md px-6 space-x-4 py-3 lg:text-2xl flex border-2 border-dark-green bg-dark-green main-cta text-white hover:bg-white hover:border-2 hover:border-green-500 hover:text-green-500 transition ease-in-out duration-500">
                                <span class="my-auto">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    class="h-7 w-7" 
                                    fill="none" 
                                    viewBox="0 0 24 24" 
                                    stroke="currentColor" 
                                    stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </span>
                            <span class="font-semibold my-auto">
                                Donate Today
                            </span>
                        </router-link>
                    </div>
                    
                </div>
            </div>
        </section>

        <!-- Therapy Fund -->
        <section class="h-screen-50 bg-gray-50 px-6 py-10 xl:py-24 xl:px-48 3xl:px-96 3xl:py-32" id="therapy-fund">
            <div class="space-y-4 md:grid md:grid-cols-2 md:gap-10">
                <div>
                    <h5 class="font-semibold text-gray-600">The</h5>
                    <h2 class="text-black font-bold text-3xl xl:text-5xl">Therapy Fund</h2>
                    <div class="py-10">
                        <p class="text-base xl:text-lg">
                            The general therapy fund helps provide discounted therapy sessions to clients seeking mental health counseling through Thrive Unburdened. To ensure this is a fair process to all applying, we use the federal poverty guidelines to determine client eligibility.
                        </p>
                    </div>
                    <div class="pb-6 md:hidden">
                        <img 
                            class="rounded-xl shadow"
                            src="@/assets/images/morning-woman.jpg" 
                            alt="Morning Woman">
                    </div>
                    <div>
                        <router-link to="/donate" class="rounded-full justify-center w-auto lg:w-96 shadow-md px-6 space-x-4 py-3 lg:text-2xl flex border-2 border-dark-green bg-dark-green main-cta text-white hover:bg-white hover:border-2 hover:border-green-500 hover:text-green-500 transition ease-in-out duration-500">
                                <span class="my-auto">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    class="h-7 w-7" 
                                    fill="none" 
                                    viewBox="0 0 24 24" 
                                    stroke="currentColor" 
                                    stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </span>
                            <span class="font-semibold my-auto">
                                Donate to The Fund
                            </span>
                        </router-link>
                    </div>
                    
                </div>
                <div class="hidden md:flex">
                    <img 
                        class="rounded-xl shadow md:my-auto"
                        src="@/assets/images/morning-woman.jpg" 
                        alt="Woman">
                </div>
            </div>
        </section>
        <!-- Client Campaigns -->
        <section class="h-screen-50 bg-white px-6 py-10 xl:py-24 xl:px-48 3xl:px-96 3xl:py-32" id="campaigns">
            <div class="md:grid md:grid-cols-2 md:gap-10">
                <div class="hidden md:flex">
                    <img 
                        class="rounded-xl shadow md:my-auto"
                        src="@/assets/images/client-woman.jpg" 
                        alt="Troubled Woman">
                </div>
                <div class="pl-4">
                    <h5 class="font-semibold text-gray-600">Campaigns</h5>
                    <h2 class="text-black font-bold text-3xl xl:text-5xl">Client-Centered Campaigns</h2>
                    <div class="py-10">
                        <p class="text-base xl:text-lg">
                            The client-centered campaigns support current Thrive Unburdened clients whose functioning have been extremely impacted by their mental health and who are facing severe financial difficulties. The clients featured have requested fundraising on their behalf and have given permission for their stories to be published with the campaign.
                        </p>
                    </div>
                    <div class="pb-6 md:hidden">
                        <img 
                            class="rounded-xl shadow"
                            src="@/assets/images/client-woman.jpg" 
                            alt="Woman">
                    </div>
                    <div>
                        <router-link to="/donate" class="rounded-full justify-center w-auto lg:w-96 shadow-md px-6 space-x-4 py-3 text-sm xs:text-base lg:text-2xl flex border-2 border-dark-green bg-dark-green main-cta text-white hover:bg-white hover:border-2 hover:border-green-500 hover:text-green-500 transition ease-in-out duration-500">
                                <span class="my-auto">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    class="h-7 w-7" 
                                    fill="none" 
                                    viewBox="0 0 24 24" 
                                    stroke="currentColor" 
                                    stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </span>
                            <span class="font-semibold my-auto">
                                Donate to a Campaign
                            </span>
                        </router-link>
                    </div>
                    
                </div>
                
            </div>
        </section>

        <!-- How it Works -->
        <section class="h-screen-50 bg-gray-50 py-24 px-8 xl:px-48 3xl:px-96" id="how-it-works">
            <div class="w-screen-80 text-center md:text-left">
                <h5 class="font-semibold text-gray-600">How to Donate</h5>
                <h2 class="text-black font-bold text-2xl 3xl:text-5xl">Donate to a fund in just 3 simple steps.</h2>
            </div>
            <div class="lg:flex mt-10 space-y-10 lg:space-x-16 md:space-y-0 md:grid md:gap-6 md:grid-cols-2">
                <div class="my-auto text-center md:text-left">
                    <div class="flex space-x-4 justify-center md:justify-start">
                        <span class="px-5 py-2.5 bg-dark-green rounded-full font-bold text-white text-3xl relative my-auto">1</span>
                    </div>
                    <div class="pt-6 lg:pt-10">
                        <h3 class="font-bold text-gray-800 text-xl lg:text-2xl">Pick a campaign or fund</h3>
                        <p class="text-gray-600">Choose a Client-Centered Campaign or the Therapy Fund.</p>
                    </div>
                </div>
                <div class="my-auto text-center md:text-left">
                    <div class="flex space-x-4 justify-center md:justify-start">
                        <span class="px-5 py-2.5 bg-dark-green rounded-full font-bold text-white text-3xl relative">2</span>
                    </div>
                    
                    <div class="pt-6 lg:pt-10">
                        <h3 class="font-bold text-gray-800 text-xl lg:text-2xl">Select a dollar amount</h3>
                        <p class="text-gray-600">Donate any amount you choose.</p>
                    </div>
                </div>
                <div class="my-auto pb-4 text-center md:text-left">
                    <div class="flex space-x-4 justify-center md:justify-start">
                        <span class="px-5 py-2.5 bg-dark-green rounded-full font-bold text-white text-3xl relative">3</span>
                    </div>
                    
                    <div class="pt-6 lg:pt-10">
                        <h3 class="font-bold text-gray-800 text-xl lg:text-2xl">Submit your donation</h3>
                        <p class="text-gray-600">That's it! Your donation will help someone access therapy.</p>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import DonateIcon from '@/components/icons/DonateIcon'
import WomanMeditating from '@/components/WomanMeditating'
export default {
    name: 'Home',
    components: {
        DonateIcon,
        WomanMeditating
    }
}
</script>

<style scoped>
    @media screen and (min-width: 1800px){
       .left-header-side{
            background: url('../assets/images/mental-health-animate.svg');
            background-repeat: no-repeat;
            background-size: 57rem;
            background-position-y: -4.7rem;
        }
    }
    
</style>